/**
 * App router. Client-side routing via React Router.
 *
 * IMPORTANT (deploy): because this is a client-routed SPA on S3 + CloudFront,
 * the CloudFront distribution must map 403/404 → /index.html (200) so deep links
 * like /queue resolve to the app instead of an S3 error. See serverless.yml and
 * the README "CloudFront SPA note".
 */
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { RequireAuth } from "./auth/RequireAuth";
import { EnvWatermark } from "./components/EnvWatermark";
import { Layout } from "./components/Layout";
import { Home } from "./routes/Home";
import { Login } from "./routes/Login";
import { Privacy } from "./routes/Privacy";
import { Terms } from "./routes/Terms";
import { AuthCallback } from "./routes/AuthCallback";
import { Queue } from "./routes/Queue";
import { Donations } from "./routes/Donations";
import { Settings } from "./routes/Settings";
import { StreamView } from "./routes/StreamView";
import { Account } from "./routes/Account";
import { Overlay } from "./routes/Overlay";
import { NotFound } from "./routes/NotFound";

export function App() {
  return (
    <BrowserRouter>
      <EnvWatermark />
      <Routes>
        {/* Public marketing landing page; auth-aware — Home redirects an
            authenticated session straight through to /queue itself. */}
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/auth/callback" element={<AuthCallback />} />
        {/* Public OBS browser-source page (issue #9) — no session cookie, so it
            can't live under RequireAuth/Layout like everything else. */}
        <Route path="/overlay/:token" element={<Overlay />} />
        {/* Authed tabs share the top-bar chrome + stream selection in Layout. */}
        <Route
          element={
            <RequireAuth>
              <Layout />
            </RequireAuth>
          }
        >
          <Route path="/queue" element={<Queue />} />
          <Route path="/donations" element={<Donations />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/streamview" element={<StreamView />} />
          <Route path="/account" element={<Account />} />
        </Route>
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}
